import { render, staticRenderFns } from "./EditLanguage.vue?vue&type=template&id=2179c2e3&scoped=true&"
import script from "./EditLanguage.vue?vue&type=script&lang=js&"
export * from "./EditLanguage.vue?vue&type=script&lang=js&"
import style0 from "./EditLanguage.vue?vue&type=style&index=0&id=2179c2e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2179c2e3",
  null
  
)

export default component.exports